import {FC, ReactNode} from 'react'
import style from './container.module.scss'
import clsx from 'clsx'

interface IProps {
  children: ReactNode
  className?: string
  section?: boolean
}

export const Container: FC<IProps> = ({children, className, section = false}) => {

  if (section) return (
    <section className={clsx(style.container, className)}>
      {children}
    </section>
  )

  return (
    <div className={clsx(style.container, className)}>
      {children}
    </div>
  )
}